/* tslint:disable */
/* eslint-disable */
/**
 * WebCore
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { APAADMINBaseModelsDeploymentBulkResult } from '../Models';
// @ts-ignore
import type { APAADMINBaseModelsDeploymentPageAnalysis } from '../Models';
// @ts-ignore
import type { APAADMINBaseModelsDeploymentSummary } from '../Models';
// @ts-ignore
import type { APAADMINBaseModelsPageOutOfSyncItem } from '../Models';
// @ts-ignore
import type { APAADMINBaseModelsSingletonOutOfSyncItem } from '../Models';
// @ts-ignore
import type { DeploymentQueueItem } from '../Models';
/**
 * DeploymentApi - axios parameter creator
 */
export const DeploymentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentDeploymentQueueDeployPost: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/deployment-queue/deploy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentDeploymentQueueGet: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/deployment-queue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentLockGet: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/lock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {boolean} [includeAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncAnalysisGet: async (target?: string, includeAll?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/page/out-of-sync/analysis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            if (includeAll !== undefined) {
                localVarQueryParameter['includeAll'] = includeAll;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncDeployPost: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/page/out-of-sync/deploy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncGet: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/page/out-of-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageStorageOrphansGet: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/page/storage-orphans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPromotePost: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/promote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSchemaKeyLanguageDeployPreviewPost: async (schemaKey: string, language: string, slug?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaKey' is not null or undefined
            assertParamExists('apiDeploymentSchemaKeyLanguageDeployPreviewPost', 'schemaKey', schemaKey)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('apiDeploymentSchemaKeyLanguageDeployPreviewPost', 'language', language)
            const localVarPath = `/api/deployment/{schemaKey}/{language}/deploy/preview`
                .replace('{schemaKey}', encodeURIComponent(String(schemaKey)))
                .replace('{language}', encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSchemaKeyLanguageDeployProductionPost: async (schemaKey: string, language: string, slug?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'schemaKey' is not null or undefined
            assertParamExists('apiDeploymentSchemaKeyLanguageDeployProductionPost', 'schemaKey', schemaKey)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('apiDeploymentSchemaKeyLanguageDeployProductionPost', 'language', language)
            const localVarPath = `/api/deployment/{schemaKey}/{language}/deploy/production`
                .replace('{schemaKey}', encodeURIComponent(String(schemaKey)))
                .replace('{language}', encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (slug !== undefined) {
                localVarQueryParameter['slug'] = slug;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSingletonOutOfSyncGet: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/singleton/out-of-sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSummaryGet: async (target?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeploymentApi - functional programming interface
 */
export const DeploymentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeploymentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentDeploymentQueueDeployPost(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsDeploymentBulkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentDeploymentQueueDeployPost(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentDeploymentQueueDeployPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentDeploymentQueueGet(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeploymentQueueItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentDeploymentQueueGet(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentDeploymentQueueGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentLockGet(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentLockGet(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentLockGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {boolean} [includeAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPageOutOfSyncAnalysisGet(target?: string, includeAll?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APAADMINBaseModelsDeploymentPageAnalysis>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPageOutOfSyncAnalysisGet(target, includeAll, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPageOutOfSyncAnalysisGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPageOutOfSyncDeployPost(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsDeploymentBulkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPageOutOfSyncDeployPost(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPageOutOfSyncDeployPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPageOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APAADMINBaseModelsPageOutOfSyncItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPageOutOfSyncGet(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPageOutOfSyncGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPageStorageOrphansGet(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPageStorageOrphansGet(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPageStorageOrphansGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentPromotePost(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsDeploymentBulkResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentPromotePost(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentPromotePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey, language, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentSchemaKeyLanguageDeployPreviewPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey, language, slug, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentSchemaKeyLanguageDeployProductionPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentSingletonOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<APAADMINBaseModelsSingletonOutOfSyncItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentSingletonOutOfSyncGet(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentSingletonOutOfSyncGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeploymentSummaryGet(target?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<APAADMINBaseModelsDeploymentSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeploymentSummaryGet(target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DeploymentApi.apiDeploymentSummaryGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DeploymentApi - factory interface
 */
export const DeploymentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeploymentApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentDeploymentQueueDeployPost(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsDeploymentBulkResult> {
            return localVarFp.apiDeploymentDeploymentQueueDeployPost(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentDeploymentQueueGet(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<DeploymentQueueItem>> {
            return localVarFp.apiDeploymentDeploymentQueueGet(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentLockGet(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentLockGet(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {boolean} [includeAll] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncAnalysisGet(target?: string, includeAll?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<APAADMINBaseModelsDeploymentPageAnalysis>> {
            return localVarFp.apiDeploymentPageOutOfSyncAnalysisGet(target, includeAll, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncDeployPost(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsDeploymentBulkResult> {
            return localVarFp.apiDeploymentPageOutOfSyncDeployPost(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<APAADMINBaseModelsPageOutOfSyncItem>> {
            return localVarFp.apiDeploymentPageOutOfSyncGet(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPageStorageOrphansGet(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.apiDeploymentPageStorageOrphansGet(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentPromotePost(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsDeploymentBulkResult> {
            return localVarFp.apiDeploymentPromotePost(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey, language, slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} schemaKey 
         * @param {string} language 
         * @param {string} [slug] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey, language, slug, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSingletonOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<APAADMINBaseModelsSingletonOutOfSyncItem>> {
            return localVarFp.apiDeploymentSingletonOutOfSyncGet(target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [target] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeploymentSummaryGet(target?: string, options?: RawAxiosRequestConfig): AxiosPromise<APAADMINBaseModelsDeploymentSummary> {
            return localVarFp.apiDeploymentSummaryGet(target, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeploymentApi - object-oriented interface
 */
export class DeploymentApi extends BaseAPI {
    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentDeploymentQueueDeployPost(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentDeploymentQueueDeployPost(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentDeploymentQueueGet(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentDeploymentQueueGet(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentLockGet(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentLockGet(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {boolean} [includeAll] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPageOutOfSyncAnalysisGet(target?: string, includeAll?: boolean, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPageOutOfSyncAnalysisGet(target, includeAll, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPageOutOfSyncDeployPost(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPageOutOfSyncDeployPost(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPageOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPageOutOfSyncGet(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPageStorageOrphansGet(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPageStorageOrphansGet(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentPromotePost(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentPromotePost(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} schemaKey 
     * @param {string} language 
     * @param {string} [slug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentSchemaKeyLanguageDeployPreviewPost(schemaKey, language, slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} schemaKey 
     * @param {string} language 
     * @param {string} [slug] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey: string, language: string, slug?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentSchemaKeyLanguageDeployProductionPost(schemaKey, language, slug, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentSingletonOutOfSyncGet(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentSingletonOutOfSyncGet(target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [target] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiDeploymentSummaryGet(target?: string, options?: RawAxiosRequestConfig) {
        return DeploymentApiFp(this.configuration).apiDeploymentSummaryGet(target, options).then((request) => request(this.axios, this.basePath));
    }
}

